import { useContext, useEffect, useState } from "react"
import { ToolContext } from "../../../core/context/ToolContext";
import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";
import { GetRandomThreeResult } from "../toolUsage/global/Format";
import { admin_exam_graph, admin_exam_list_quiz, admin_topic_graph, admin_topic_list, getGlobalProfession } from "../../../core/request/Global";
import { useLocation } from "react-router-dom";
// import moment from "moment";

// const tool_id =  process.env.REACT_APP_TID_BIZ;
// const global_id = process.env.REACT_APP_GLOBAL_ID;

export const RenderAPI = () => {
    const { tool_state, speaker_state, provider_state, home_state } = useContext(ToolContext)
    const { __SESSION, globalLoader, toolOwned, validateAccount, toolShuffle } = tool_state
    const location = useLocation();

    const validateProfession = async () => {
        try {
            const data = await getGlobalProfession({ aid: tool_state.__SESSION.data.ainfo.aid });
            const role = tool_state.__SESSION.data?.uaccess[0].role_name;
            const currentPath = window.location.pathname;

            if (data.length === 0 && role === "Regular User" && currentPath !== '/biz/professional') {
                tool_state.openPModal.set(true);
            } else {
                tool_state.openPModal.set(false);
            }
            tool_state.pData.set({...tool_state.pData.data, id: data.length > 0 ? data[0].id: '' ,first_name: (tool_state.__SESSION.data.pinfo.length > 0 ? tool_state.__SESSION.data.pinfo[0].first_name : '') , middle_name:'', last_name: (tool_state.__SESSION.data.pinfo.length > 0 ? tool_state.__SESSION.data.pinfo[0].last_name : ''), suffix: (tool_state.__SESSION.data.pinfo.length > 0 ? tool_state.__SESSION.data.pinfo[0].suffix : ''), prc_id_expiry_date:data.length > 0 ? data[0].valid_until : null, profession:data[0]?.profession_id, prc_license:data.length > 0 ? data[0]?.prc_license_num: null });
        } catch (err) {
            console.error("Error validating profession:", err);
        }
    };

    
    const __init = async() => {
        await globalLoader.set(true)
        // await __runactiveuser()
       
        //GET TOOL OWNED
        let prms = __SESSION.data.uaccess[0].role_id === 0 ? {aid:__SESSION.data.ainfo.aid, platform:'business' } : {aid:__SESSION.data.ainfo.aid, platform:'business', ref:0, owner_id:__SESSION.data.uaccess[0].owner_id }
        let resTool = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/tools/owned`, prms)
        toolOwned.set(resTool)
        if (resTool.length > 3) {
            const res = GetRandomThreeResult(resTool);
            toolShuffle.set(res)
        }

        //SPEAKER LIST
        let speakerList = await rqx.get(`<<tool>>/${env()}/biz_speaker/read`, {company_id:tool_state.cinfo.data[0].company_id,})
        speaker_state.slist.set(speakerList)
        // console.log(speakerList)
        
        const graphTopic = await admin_topic_graph({company_id:tool_state.cinfo.data[0].company_id})
        const graphExam = await admin_exam_graph({company_id:tool_state.cinfo.data[0].company_id})
        home_state.graph.set({...home_state.graph.data, topic:{completed: parseInt(graphTopic[0].completed_percentage), ongoing: parseInt(graphTopic[0].ongoing_percentage), enrolled: parseInt(graphTopic[0].enrolled_percentage)}, exam:{ passed: parseInt(graphExam[0].passed_percentage), failed: parseInt(graphExam[0].failed_percentage) , ongoing: parseInt(graphExam[0].ongoing_percentage) }})
        const getTtopics = await admin_topic_list({company_id:tool_state.cinfo.data[0].company_id})
        const getTExam = await admin_exam_list_quiz({company_id:tool_state.cinfo.data[0].company_id})
        home_state.acd.set({...home_state.acd.data, topic: getTtopics, exam:getTExam})
        // console.log(getTExam)
        
        await validateProfession();
        await globalLoader.set(false)
    }

    const [subscribe, setSubscribe] = useState(true)

    useEffect(() => {
        if (subscribe) {
            if (globalLoader.data) {
                __init()
            }
        }
        return () => setSubscribe(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateAccount.data])

    useEffect(() => {
        validateProfession();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    
    return (
        <></>
    )
}